import { Show } from '@elfsight/lib-utils';
import { useCountdownTimerState } from './countdown-timer-state-context';
import { FormPopup } from './form-popup';
import { Layout } from './layout';

export function Widget() {
  const { state } = useCountdownTimerState();

  return (
    <Show when={state !== 'closed'}>
      <Layout />

      <FormPopup />
    </Show>
  );
}
